import ApiBase from '../ApiBase';

class Version extends ApiBase {
  /**
   * @method fetch
   * @return {Promise<*>}
   */
  fetch = () => {
    return this.get('version');
  };
}

export default new Version();
